{
  "actionSelectLabel": "Action",
  "createScheduleHelpContent": "Quick Scheduler is a feature that allows you to create a schedule to turn on a pump or valve at a specific time or for a specific duration.\n\nSchedules can either be set to run once or to repeat on specific days of the week. To schedule a single execution, select \"Do Once\"; otherwise, select \"Repeat\".\n\nPlease note that this feature is intended to be used with pumps and valves that can be turned on by FarmHQ. Using this feature with shutdown-only pumps or other types of equipment may have unintended consequences.",
  "createScheduleHelpTitle": "About Quick Scheduler",
  "dayPickerLabel": "Day",
  "delayedShutdownTitle": "Delayed Shutdown",
  "deviceSelectLabel": "Device",
  "deviceSelectPlaceholder": "(Choose Device)",
  "durationHoursLabel": "Hours",
  "durationMinutesLabel": "Minutes",
  "errorMessages": {
    "DURATION_BELOW_MINIMUM": "Duration must be greater than 0 minutes.",
    "EXECUTION_TIME_IN_PAST": "Execution time cannot be in the past.",
    "NO_COMPATIBLE_DEVICES": "No compatible devices found,",
    "NO_REPEATING_DAYS": "Schedule must repeat on at least one day.",
    "SCHEDULE_END_BEFORE_START": "Schedule end is before start.",
    "SCHEDULE_END_IN_PAST": "Schedule end cannot be in the past.",
    "SCHEDULE_START_IN_PAST": "Schedule start cannot be in the past.",
    "SHUTDOWN_IN_PAST": "Shutdown must be in the future"
  },
  "executeAt": "Execute At",
  "executeAtWithTimezone": "Execute At ({{timezone}})",
  "executionDay": "Execution Day",
  "frequencyLabel": "Frequency",
  "linkToCreateSchedule": "New Schedule",
  "linkToDelayedShutdown": "Delayed Shutdown",
  "next": "Next",
  "nextDay": "Next Day",
  "back": "Back",
  "cancel": "Cancel",
  "noCompatibleDevices": "No compatible devices found,",
  "quickSchedulerTitle": "Quick Scheduler",
  "repeatOnDays": "Repeat on Days",
  "scheduleEndLabel": "Schedule End",
  "scheduleFrequencyTypes": {
    "doOnce": "Do Once",
    "repeat": "Repeat"
  },
  "schedulePumpingSession": "Schedule Pumping Session",
  "scheduleStartLabel": "Schedule Start",
  "shutdownPumpAt": "Shutdown Pump At",
  "submit": "Submit",
  "timePickerLabel": "Time",
  "turnOfThePumpForWithVal": "Turn off the pump for {{val}}",
  "turnOffThePumpAfter": "Turn off the pump after",
  "turnOnThePumpAt": "Turn on the pump at",
  "turnOnThePumpAtWithTimezone": "Turn on the pump at ({{timezone}})",
  "usageWarning": "This feature is intended to be used with pumps and valves that can be turned on by FarmHQ. Using this feature with shutdown-only pumps or other types of equipment may have unintended consequences."
}
